import { useEffect, useState } from "react";
import { IPanelInsertarCatalogo } from "./PanelInsertarCatalogo";
import { codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ICrearCatalogo } from "../../../../../Interfaces/hazard/IHazard";
import { CatalogoInseguroService } from "../../../../../services/hazard/catalogoInseguroService";

export const UsePanelInsertarCatalogo=(props:IPanelInsertarCatalogo)=>{
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [request,setRequest]=useState<ICrearCatalogo>({nombreCatalogo:"",esCondicion:props.esCondicion})
    const reset=()=>{
        setMensaje("")
        setRequest({nombreCatalogo:"",esCondicion:props.esCondicion})
        setStatus(0)
        props.onDismiss()
    }
    const required: (keyof ICrearCatalogo)[] = [
        "nombreCatalogo",
    ];
    useEffect(()=>{
        console.log("request",request)
    },[request])
    useEffect(()=>{
        console.log(props.esCondicion)
    },[props.esCondicion])
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])
    const postInsertarCatalogo=()=>{
        setLoading(true)
        CatalogoInseguroService.CrearCatalogo(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },
                3000)
            }else{
                setStatus(500)
                setMensaje("Error Inesperado");
            }
            setLoading(false)
           
        }).catch((e)=>{
              console.log('Error detallado:', e);
              setMensaje("Error Inesperado");
              setStatus(500);
              setLoading(false);
        })}
    return {request,setRequest,postInsertarCatalogo,loading,disableForm,reset,mensaje,status}
}